import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { useSearchParams } from 'react-router-dom';

import LinkOpenBanking from './LinkOpenBanking';
import { LinkOpenBankingDocumentRequirementContent } from './LinkOpenBankingDocumentRequirementContent/LinkOpenBankingDocumentRequirementContent';
import styles from './TrueLayer.module.css';
import { TTrueLayerAlertStatus } from '../../../types';
import DocumentRequirement from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  setAlertStatus: (status: TTrueLayerAlertStatus) => void;
  setSuccessorBankId: (bankId: string | undefined) => void;
};

const OpenBanking = ({ setAlertStatus, setSuccessorBankId }: TProps) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const statusCode = searchParams.get('status_code');
    const errorDetail = searchParams.get('error_detail');
    const subCode = searchParams.get('sub_code');

    // Only the provider_migrated branch sets a successor; reset first so a
    // stale id can't linger across a later success/cancel/failure.
    setSuccessorBankId(undefined);

    if (statusCode === '200') {
      tracking.ampli.openBankingLinkedSuccessfully();
      setAlertStatus('success');
    } else if (statusCode === '500') {
      // ProviderMigrated takes precedence over access_denied, matching the
      // backend (error_detail carries the successor bank id, e.g. ob-lloyds).
      if (subCode === 'ProviderMigrated') {
        tracking.ampli.openBankingLinkingFailed({
          reason: 'provider_migrated',
        });
        setSuccessorBankId(errorDetail ?? undefined);
        setAlertStatus('provider_migrated');
      } else if (errorDetail === 'access_denied') {
        tracking.ampli.openBankingLinkingCancelled();
        setAlertStatus('cancel');
      } else {
        tracking.ampli.openBankingLinkingFailed({ reason: 'unknown' });
        setAlertStatus('failure');
      }
    }
  }, [searchParams]);

  return (
    <DocumentRequirement
      className={styles.documentRequirement}
      documentType="bank statement"
      customButton={<LinkOpenBanking />}
    >
      <LinkOpenBankingDocumentRequirementContent />
    </DocumentRequirement>
  );
};

export default OpenBanking;
